import React from 'react'

function Delete() {
  return (
    <div>The user has been deleted.</div>
  )
}

export default Delete